import { Component } from '@angular/core';
import { soundpostReportOutputAccountingEntryLineEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Report Output Accounting Entry Lines') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostreportoutputaccountingentryline-form',
    templateUrl: './soundpostreportoutputaccountingentryline.form.component.html'
})
export class soundpostReportOutputAccountingEntryLineFormComponent extends BaseFormComponent {
    public record!: soundpostReportOutputAccountingEntryLineEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

